module.exports = __webpack_public_path__ + "img/3x.ab34f40.jpg";